export default function ManageSharedAssetsModalController($scope, $uibModalInstance) {
  'ngInject';
  $scope.revokeShare = function() {
    $uibModalInstance.close();
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };
}
